import { render } from "./ContextPopUp.vue?vue&type=template&id=4d713354&scoped=true"
import script from "./ContextPopUp.vue?vue&type=script&lang=js"
export * from "./ContextPopUp.vue?vue&type=script&lang=js"

import "./ContextPopUp.vue?vue&type=style&index=0&id=4d713354&scoped=true&lang=css"

import exportComponent from "/Users/mattia/Desktop/Projects/elbi-website-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d713354"]])

export default __exports__